export default function DirectorProfileSection() {
  return (
    <section className="min-h-screen bg-stone-50 py-36">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* メッセージ */}
        <div className="text-center mb-20">
          <h1 className="text-3xl lg:text-4xl font-bold text-[#1e3a5f] mb-6">
            設計から伴走する制作パートナー
          </h1>
          <div className="w-24 h-1 bg-[#1e3a5f] mx-auto"></div>
        </div>

        {/* ディレクタープロフィール */}
        <div className="bg-white p-8 lg:p-10 rounded-xl mb-20 shadow-sm">
          <div className="flex flex-col lg:flex-row items-center gap-6">
            {/* プロフィール画像 */}
            <div className="flex-shrink-0">
              <img 
                src="https://static.readdy.ai/image/b90f078cf90066d31dc5715f1c64017a/9e403cccf1aee5a1f77d2f1668083bd1.png"
                alt="ディレクター プロフィール写真"
                className="w-14 h-14 rounded-full object-cover object-top shadow-lg"
              />
            </div>
            
            {/* 基本情報 */}
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-xl font-bold text-[#1e3a5f]">技術責任者／Webディレクター（YUSEI）</h2>
            </div>
          </div>
        </div>

        {/* 経歴詳細 */}
        <div className="space-y-16">
          {/* 学歴・資格 */}
          <div className="bg-white rounded-xl shadow-sm p-10 lg:p-12">
            <h3 className="text-xl font-bold text-[#1e3a5f] mb-8 flex items-center">
              <i className="ri-graduation-cap-line text-[#1e3a5f] mr-3"></i>
              専門性とバックグラウンド
            </h3>
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p>
                2022年、神戸大学国際人間科学部を卒業後、<br />
                同大学大学院(人間発達環境学研究科・有機化学専攻)を修了。
              </p>
              
              <p>
                在学中にカナダ留学を経験し、TOEIC 930点を取得。
              </p>
              
              <p>
                大学院では研究活動を通じて、<br />
                仮説検証とトライアンドエラーを繰り返す姿勢を培いました。
              </p>
              
              <p>
                この「論理的に考え、粘り強く解決する力」は、<br />
                現在のWeb制作にも活かされています。
              </p>
            </div>
          </div>

          {/* 対応領域・技術 */}
          <div className="bg-white border border-stone-200 p-10 lg:p-12 rounded-xl shadow-sm">
            <h3 className="text-xl font-bold text-[#1e3a5f] mb-10 flex items-center gap-3">
              <div className="w-8 h-8 bg-[#1e3a5f] rounded-lg flex items-center justify-center">
                <i className="ri-code-line text-white text-lg"></i>
              </div>
              対応領域・技術
            </h3>
            <div className="space-y-12">
              {/* コーディング */}
              <div className="border-l-4 border-[#1e3a5f] pl-6">
                <h4 className="font-semibold text-[#1e3a5f] mb-6 text-lg">コーディング</h4>
                <ul className="space-y-5">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#1e3a5f] text-lg mt-0.5"></i>
                    <span className="text-gray-700">ユーザーの視線を誘導するアニメーション設計と実装（GSAP）</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#1e3a5f] text-lg mt-0.5"></i>
                    <span className="text-gray-700">BEM / FLOCSSによるCSS設計</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#1e3a5f] text-lg mt-0.5"></i>
                    <span className="text-gray-700">レイアウトバランスを重視した高精度なコーディング</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#1e3a5f] text-lg mt-0.5"></i>
                    <span className="text-gray-700">Gulp環境での構築</span>
                  </li>
                </ul>
              </div>

              {/* WordPress */}
              <div className="border-l-4 border-[#1e3a5f] pl-6">
                <h4 className="font-semibold text-[#1e3a5f] mb-6 text-lg">WordPress</h4>
                <ul className="space-y-5">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#1e3a5f] text-lg mt-0.5"></i>
                    <span className="text-gray-700">カスタム投稿 / カスタムフィールド / タクソノミー構築</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#1e3a5f] text-lg mt-0.5"></i>
                    <span className="text-gray-700">デザインカンプからのオリジナルテーマ制作</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#1e3a5f] text-lg mt-0.5"></i>
                    <span className="text-gray-700">静的サイトのWordPress化</span>
                  </li>
                </ul>
              </div>

              {/* Shopify */}
              <div className="border-l-4 border-[#1e3a5f] pl-6">
                <h4 className="font-semibold text-[#1e3a5f] mb-6 text-lg">Shopify</h4>
                <ul className="space-y-5">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#1e3a5f] text-lg mt-0.5"></i>
                    <span className="text-gray-700">CSS調整(フォント・サイズ・色など)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#1e3a5f] text-lg mt-0.5"></i>
                    <span className="text-gray-700">OS1.0からOS2.0への移行</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#1e3a5f] text-lg mt-0.5"></i>
                    <span className="text-gray-700">Liquid編集(住所フォーム変更、オリジナルセクション作成 等)</span>
                  </li>
                </ul>
              </div>

              {/* 注記 */}
              <div className="bg-stone-100 p-6 rounded-lg">
                <p className="text-gray-700 text-center">
                  <strong className="text-[#1e3a5f]">上記以外の内容も、柔軟に対応いたします。</strong>
                </p>
              </div>
            </div>
          </div>

          {/* Web制作への想い */}
          <div className="bg-white border border-stone-200 p-10 lg:p-12 rounded-xl shadow-sm">
            <h3 className="text-xl font-bold text-[#1e3a5f] mb-10 flex items-center gap-3">
              <div className="w-8 h-8 bg-[#1e3a5f] rounded-lg flex items-center justify-center">
                <i className="ri-heart-line text-white text-lg"></i>
              </div>
              Web制作への想い
            </h3>
            <div className="space-y-7 text-gray-700 leading-relaxed">
              <p>
                大学時代からWebの仕組みに興味を持ち、<br />
                コロナ禍をきっかけに本格的に学習を開始しました。
              </p>
              
              <p>
                HTMLやCSSがブラウザに反映された瞬間の感動。<br />
                初めて実装が意図通りに動いた瞬間の達成感、
              </p>
              
              <p>
                その体験を通じて、<br />
                「アイデアを形にする」仕事の面白さに強く惹かれました。
              </p>
              
              <p>
                Web制作は明確な規格に基づくロジカルな世界です。<br />
                だからこそ、課題が発生しても論理的に原因を突き止め、<br />
                着実に解決へ導くことができます。
              </p>
              
              <p className="font-semibold text-[#1e3a5f]">
                一つひとつ丁寧に誠実に、<br />
                そして責任を持って制作いたします。
              </p>
              
              <p className="text-sm text-gray-600 pt-4">
                代表と連携し、戦略設計と技術実装の両面からサポートいたします。
              </p>
            </div>
          </div>

          {/* 戻るボタン */}
          <div className="text-center pt-12">
            <a 
              href="/"
              className="inline-flex items-center gap-2 bg-[#1e3a5f] hover:bg-[#2d4a6f] text-white px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line text-lg"></i>
              ホームに戻る
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}